const FormConstants = {
  dateFormat: 'MM/DD/YYYY'
};

export default FormConstants;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/constants.js